import * as instruments from './instruments'
import {instantiateInstrument} from "./instruments"

export default class Position {
    constructor(positionDict) {
        this.instrument = instantiateInstrument(positionDict.instrument)
        this.units = positionDict.units
        this.price = positionDict.price
    }

    calcEquityScenarioPL(shift, price) {
        const scenarioPL = this.instrument.calcEquityScenarioPL(shift, price) * this.units
        return scenarioPL
    }

    calcValue() {
        return this.units * this.price * this.instrument.multiplier
    }

    calcValueScenario(marketDataObj, asOfDateObj, spotPriceOverride = null) {
        let multiplier = this.instrument.multiplier == null ? 1 : this.instrument.multiplier
        return this.units * multiplier * this.instrument.calcPriceScenario(marketDataObj, asOfDateObj, spotPriceOverride)
    }
}


export function collapsePositions(inputPositions) {
    console.log('collapse', inputPositions)
    let outputPositions = []

    for (let i = 0; i < inputPositions.length; i++) {
        let index = outputPositions.findIndex(pos => pos.instrument.getName() === inputPositions[i].instrument.getName())

        if (index < 0) {
            outputPositions.push(inputPositions[i])
        } else {
            outputPositions[index].units += inputPositions[i].units
        }
    }

    return outputPositions
}
